// @flow
/**
 * Created by Mike Chung on 2/9/18.
 */

import type {LoadFairConfigActionCollection} from "../actions/app/fairConfigAction";
import FairConfig from "../model/fair/FairConfig";
import * as _ from 'lodash';
import moment from "moment";

export type FairConfigState = {
    list: Array<FairConfig>,
    configByProjectCode: {
        [projectCode: string]: {
            [year: string]: FairConfig
        }
    }
}

const INITIAL_STATE: FairConfigState = {
    list: [],
    configByProjectCode: {}
};

export default function reducer(state: FairConfigState = INITIAL_STATE, action: LoadFairConfigActionCollection): FairConfigState {

    switch (action.type) {
        case "app/LOAD_FAIR_CONFIG_SUCCESS_ACTION":
            let result = {
                list: [].concat(_.chain(action.fairConfigs)
                    .filter((config: FairConfig) => moment(config.fairEndDate).isSameOrAfter(new Date(), 'day'))
                    .filter((config:FairConfig) => +config.year >= new Date().getFullYear())
                    .sortBy('fairStartDate').value()),
                configByProjectCode: {}
            };
            let configByProjectCode = _.chain(action.fairConfigs).reduce((accumulatedResult: any, fairConfig: FairConfig, key: string) => {
                if (!accumulatedResult[fairConfig.projectNumber]) {
                    accumulatedResult[fairConfig.projectNumber] = {};
                }
                accumulatedResult[fairConfig.projectNumber][fairConfig.year] = fairConfig;
                return accumulatedResult;
            }, {}).value();
            result.configByProjectCode = configByProjectCode;

            return result;
        case "app/LOAD_FAIR_CONFIG_FAILED_ACTION":
        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/FairConfigReducer.js